export const Question = ({ question = "" }) => {
  return (
    <div className="flex items-center space-x-2 group text-body-loud">
      <div className="font-bold">{question}</div>
    </div>
  );
};
